import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import Home from './components/Home';
import Profile from './components/Profile';
import Projects from './components/Projects';
import Learnings from './components/Learnings';
import Certifications from './components/Certifications';
import Ideas from './components/Ideas';
import ContactMe from './components/ContactMe';
import Layout from './Layout';

const App = () => {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/learnings" element={<Learnings />} />
          <Route path="/certifications" element={<Certifications />} />
          <Route path="/ideas" element={<Ideas />} />
          <Route path="/contact-me" element={<ContactMe />} />
        </Routes>
      </Layout>
    </Router>
  );
};

export default App;